module.exports = __webpack_public_path__ + "alert-triangle.png";